import React, { Component } from 'react';

import { Offcanvas, Row, Col, Tab, Tabs, Card } from 'react-bootstrap';

import CommonButton from '../components/CommonButton';
import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';
import CommonFile from '../components/CommonFile';
import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';

/**
import CustomDatePicker from "../components/CommonDatePicker";
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/

import * as Actions from '../actions/ActionCenter';
import * as fn from '../../library/function';
import * as helper from '../../library/helper';

import SimpleBar from 'simplebar-react';
class InputCommonDataEnterprise extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date(),
            activeTab: 'profile'
        };
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); };

    handleTabSelect = (key) => { this.setState({ activeTab: key }); };

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        onUpdateState('Inputs', updatedInputs);
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }

    render = () => {
        let props = this.props;
        
        let AllowUsersTypes = ['0', '1', '3' ]; // 0=Admin, 1=EEC staff, 3=enterprise

        let { onInputChange, onCloseAlert, onSubmit, onSetEdit, onDiscardSubmit, onPreviewFile, onDeleteFile } = props;

        let { App, Action, Inputs, InputGroup, Masterbase, Operation, UserCookie } = props;        

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width':  window.innerWidth < 768 ? '80vw' : '50vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => { 
                        this.setState({activeTab: 'profile'});
                        props.onClose(e);
                    }}
                >
                    <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            <Tabs 
                                defaultActiveKey="profile" 
                                activeKey={this.state.activeTab}
                                onSelect={(e) => this.handleTabSelect(e)}
                                className="mb-3"
                            >

                                <Tab eventKey="profile" title="ข้อมูลทั่วไป">
                                    {/** 
                                    <Card bg="light">
                                        <Card.Body>
                                    */}
                                            <Row>
                                                <Col md={12}>
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.benefits_id}
                                                        option={{source: 'db', data: Masterbase?.benefits}}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col md={12}>
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.operator_name}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col md={12}>
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.target_industries_id}
                                                        option={{source: 'db', data: Masterbase?.target_industries}}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                        disabled={false}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col md={12}>
                                                    <CommonFile
                                                        element="Inputs"
                                                        input={Inputs.logo}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 

                                                        previewFile={(e) => onPreviewFile(e)} 
                                                        deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                                    />
                                                </Col>
                                            </Row> 
                                            <Row>
                                                <Col md={12}><hr className="hr-custom" /></Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.executive}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.position}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col md={6}>
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.coordinator_name}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)}
                                                        // disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.coordinator_phone_number}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col md={6}>
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.enterprise_contact}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)}
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.fax}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}><hr className="hr-custom" /></Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.status}
                                                        option={{source: 'options', section: 'status', item: 'default'}}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />
                                                </Col>
                                            </Row>
                                    {/** 
                                        </Card.Body>
                                    </Card>
                                    */}
                                </Tab>

                                <Tab eventKey="location" title="สถานที่ตั้ง">
                                   {/** 
                                    <Card bg="light">
                                        <Card.Body>
                                    */}
                                            <Row>
                                                <Col md={12}>
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.location}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col md={4}>
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.province_id}
                                                        option={{source: 'db', data: Masterbase?.province}}
                                                        hr={false}
                                                        callback={(e, element) => {
                                                            onInputChange(e, element);
                                                            onInputChange({ target: { name: 'district_id', value: '' } }, element);
                                                            onInputChange({ target: { name: 'subdistrict_id', value: '' } }, element);
                                                        }}
                                                    />
                                                </Col>
                                                <Col md={4}>
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.district_id}
                                                        option={{
                                                            source: 'db', 
                                                            data: 
                                                                Inputs.province_id.value !== '' ? 
                                                                Masterbase?.district.filter( (d) => d.province_id === Inputs.province_id.value )
                                                            : []
                                                        }}
                                                        hr={false}
                                                        callback={(e, element) => {
                                                            onInputChange(e, element);
                                                            onInputChange({ target: { name: 'subdistrict_id', value: '' } }, element);
                                                        }}
                                                    />
                                                </Col>  
                                                <Col md={4}>
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.subdistrict_id}
                                                        option={{
                                                            source: 'db', 
                                                            data: 
                                                                Inputs.district_id.value !== '' ? 
                                                                Masterbase?.subdistrict.filter(
                                                                    (s) => s.district_id === Inputs.district_id.value
                                                                )
                                                                : []
                                                        }}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)}
                                                    />
                                                </Col>
                                            </Row>
                                    {/** 
                                        </Card.Body>
                                    </Card>
                                    */}
                                </Tab>
                                
                            </Tabs>
                            
                        </SimpleBar>

                    </Offcanvas.Body>
                    
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                        
                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => {
                                    let currentId = Inputs.id.value;
                                    await onSubmit(e);
                                    if (Action.Mode === 'update') {
                                        onSetEdit({}, {id: currentId}); 
                                    }
                                    this.handleTabSelect('profile');
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>
                </Offcanvas>      
        )
    }
}

export default InputCommonDataEnterprise;